export const SEARCH_NEW_REQUEST_DASH_BOARD_LIST_ASYNC = 'SEARCH_NEW_REQUEST_DASH_BOARD_LIST_ASYNC';
export const SEARCH_NEW_REQUEST_DASH_BOARD_LIST_SUCCESS = 'SEARCH_NEW_REQUEST_DASH_BOARD_LIST_SUCCESS';
export const SEARCH_NEW_REQUEST_DASH_BOARD_LIST_FAIL = 'SEARCH_NEW_REQUEST_DASH_BOARD_LIST_FAIL';
export const RESET_NEW_REQUEST_DASH_BOARD_LIST = 'RESET_NEW_REQUEST_DASH_BOARD_LIST';

export const GET_KEY_METRICS_ASYNC = 'GET_KEY_METRICS_ASYNC';
export const GET_KEY_METRICS_SUCCESS = 'GET_KEY_METRICS_SUCCESS';

export const GET_LATEST_ACTIVITIES_LIST_ASYNC = 'GET_LATEST_ACTIVITIES_LIST_ASYNC';
export const GET_LATEST_ACTIVITIES_LIST_SUCCESS = 'GET_LATEST_ACTIVITIES_LIST_SUCCESS';

export const GET_LATEST_FILTER_ACTIVITIES_LIST_ASYNC = 'GET_LATEST_FILTER_ACTIVITIES_LIST_ASYNC';
export const GET_LATEST_FILTER_ACTIVITIES_LIST_SUCCESS = 'GET_LATEST_FILTER_ACTIVITIES_LIST_SUCCESS';

export const GET_LATEST_ACTIVITIES_WHEN_SCROLL_DOWN_ASYNC = 'GET_LATEST_ACTIVITIES_WHEN_SCROLL_DOWN_ASYNC';
export const GET_LATEST_ACTIVITIES_WHEN_SCROLL_DOWN_SUCCESS = 'GET_LATEST_ACTIVITIES_WHEN_SCROLL_DOWN_SUCCESS';



// WEBPACK FOOTER //
// ./src/Dashboard/constants.js